/**
 * Counts clicks that reach a control on the development project only.
 * The iOS retest reads window.__pacarionClicks['show-completed'].
 */

const { devTapToolsEnabled } = require('./devTapTools');

function recordControlClick(name, env) {
  if (!devTapToolsEnabled(env)) return 0;
  const label = String(name || 'click');
  const host = typeof window === 'undefined' ? global : window;
  if (!host.__pacarionClicks) host.__pacarionClicks = {};
  host.__pacarionClicks[label] = (host.__pacarionClicks[label] || 0) + 1;
  const count = host.__pacarionClicks[label];
  if (typeof console !== 'undefined' && console.log) {
    console.log('[tap] ' + label + ' ' + count);
  }
  return count;
}

module.exports = {
  recordControlClick,
};
